import { Fragment } from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/common/table/Table";
import Typography from "@/shared/components/common/Typography";

import json from "@/public/data/footerPages.json";

interface RefundRulesCardProps {
  rule: RefundRule;
}

export const CancelRulesCard = ({ rule }: RefundRulesCardProps) => {
  const {
    refundRules: { rateId, allRateId },
  } = json;

  const chunkedData = chunkAirlineData(rule, 4);

  return (
    <Table className="text-center py-2">
      {chunkedData.map(({ data, descriptions }, index) => (
        <Fragment key={index}>
          <TableHeader className="py-4 md:bg-slate-100">
            <TableRow className="border-none">
              <TableHead className="text-center py-3 px-3 md:max-w-[500px]">
                {rateId}
              </TableHead>
              {Array.from({ length: 5 }).map((item, index) => (
                <TableHead className="text-center py-3 px-3" key={index}>
                  {descriptions[index]}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>

          <TableBody>
            {data?.map((rows) => (
              <TableRow key={rows.rate_id}>
                <TableCell className="!py-6 md:max-w-[500px]">
                  <Typography className="break-words">
                    {rows.rate_id || allRateId}
                  </Typography>
                </TableCell>
                {rows.data?.map((cell, index) => (
                  <TableCell key={`cell-${index}`} className="!py-6">
                    {cell ? cell + "%" : "_"}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Fragment>
      ))}
    </Table>
  );
};

const chunkAirlineData = (airline: RefundRule, chunkSize: number) => {
  const chunked = [];

  const { data, descriptions } = airline;
  for (let i = 0; i < descriptions.length; i += chunkSize) {
    const descChunk = descriptions.slice(i, i + chunkSize);
    const percentChunk = data.map((item) => ({
      rate_id: item.rate_id,
      data: item.data.slice(i, i + chunkSize),
    }));

    chunked.push({
      descriptions: descChunk,
      data: percentChunk,
    });
  }

  return chunked;
};
